import { useMemo } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import EventIcon from '@mui/icons-material/Event';
import PersonIcon from '@mui/icons-material/Person';
import { Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import DashboardLayout from './DashboardLayout';
import useAuthStore from '../store/authStore';
import { fetchTutorStudents } from '../api/students';
import { fetchAttentionCount } from '../api/schedules';

const TutorLayout = () => {
  const { user } = useAuthStore();

  const { data: students } = useQuery({
    queryKey: ['tutor-students', user?.id],
    queryFn: () => fetchTutorStudents(user.id),
    enabled: Boolean(user?.id),
    staleTime: 0,
  });

  const { data: attentionCount } = useQuery({
    queryKey: ['schedule-attention-count'],
    queryFn: fetchAttentionCount,
    enabled: Boolean(user?.id),
    refetchInterval: 60000,
  });

  const totalIncomplete = useMemo(
    () => (students || []).reduce((sum, s) => sum + (s.incompleteLessons || 0), 0),
    [students]
  );

  const navItems = useMemo(() => [
    { label: 'Головна', path: '/tutor', icon: <HomeIcon />, exact: true },
    { label: 'Мої учні', path: '/tutor/students', icon: <MenuBookIcon />, badge: totalIncomplete || 0 },
    { label: 'Розклад', path: '/tutor/schedule', icon: <EventIcon />, badge: attentionCount || 0 },
    { label: 'Профіль', path: '/tutor/profile', icon: <PersonIcon /> },
  ], [totalIncomplete, attentionCount]);

  return (
    <DashboardLayout navItems={navItems}>
      <Outlet />
    </DashboardLayout>
  );
};

export default TutorLayout;
